import './index_mWeb.css';
import Constants from '../../../constants';
import { View, Text, Image } from '../../../component';
import Connection from '../../../utilities/Connection';
import { getPlayerName } from '../../../utilities/helper';
import React from 'react';

const ChooseCapPlayerRowMWeb = ({
  item = {},
  teamA = {},
  teamB = {},
  selectedViceCaptain = false,
  selectedCaptain = false,

  gameType
}: any) => {
  const { shortName = '', teamId = '', role, viceCaptain, captain, playerId } = item;

  const playerNameTitle = {
    color: '#fff'
  };

  const isTeamA = teamA?.teamId === teamId;
  const teamName = isTeamA ? teamA?.shortName : teamB?.shortName;

  const roleIconDimension =
    gameType === Constants.GameType.FANTASY_KABADDI
      ? 55
      : gameType === Constants.GameType.FANTASY_FOOTBALL
      ? 45
      : 35;

  const playerRoleIcon = (role: string) => {
    return (
      <View style={{ paddingRight: '20px' }}>
        {role === 'wk' || role === 'wkbat' ? (
          <Constants.Svgs.CricketWicketKeeper
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#fff'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'bat' ? (
          <Constants.Svgs.CricketBatsman
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#fff'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'all' ? (
          <Constants.Svgs.CricketAllRounder
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#fff'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'bowl' ? (
          <Constants.Svgs.CricketBowler
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#fff'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'allrounder' ? (
          <Constants.Svgs.KabaddiAllRounder
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'defender' ? (
          <Constants.Svgs.KabaddiDefenders
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'raider' ? (
          <Constants.Svgs.KabaddiRaiders
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'Goalkeeper' ? (
          <Constants.Svgs.Football_GK
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'Defender' ? (
          <Constants.Svgs.FootballDEF
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'Midfielder' ? (
          <Constants.Svgs.Football_MID
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : role === 'Forward' ? (
          <Constants.Svgs.Football_ST
            width={roleIconDimension}
            height={roleIconDimension}
            fillPrimary={'#FCC809'}
            fillSecondary={'#2F3238'}
          />
        ) : null}
      </View>
    );
  };

  const playerRowContentBG = {
    backgroundColor: '#2d353f'
  };

  const captainBG = {
    backgroundColor: '#11171d'
  };

  const captainTitle = {
    color: '#ffc400'
  };

  const viceCaptainBG = {
    backgroundColor: '#11171d'
  };

  const viceCaptainTitle = {
    color: '#ffc400'
  };

  return (
    <View className={'choose-cap-player-container_mWeb'}>
      <View className={'choose-cap-player-content-wrapper_mWeb'} style={playerRowContentBG}>
        <View className={'choose-cap-player-logo-name-wrapper_mWeb'}>
          <View
            className={'choose-cap-player-team-logo-container_mWeb'}
            style={{
              borderColor: isTeamA ? '#ffbe0f' : '#ff3c3c'
            }}>
            <View className={'choose-cap-player-image-container_mWeb'}>
              <Image
                source={`${Connection.getPlayerImageURL(playerId, gameType)}`}
                placeHolderType={'Player'}
                style={{
                  width: '100%',
                  height: '100%'
                }}
              />
              <View
                className={'choose-cap-player-team-name-container_mWeb'}
                style={{
                  backgroundColor: isTeamA ? '#ffbe0f' : '#ff3c3c'
                }}>
                <Text
                  className={'choose-cap-player-team-name_mWeb'}
                  style={{
                    color: isTeamA ? '#000' : '#fff'
                  }}>
                  {teamName}
                </Text>
              </View>
            </View>
          </View>
          <Text className={'choose-cap-player-name-text_mWeb'} style={playerNameTitle}>
            {`${getPlayerName(shortName)}`}
          </Text>
        </View>

        {captain && (
          <View className={'choose-cap-player-captain-pt-wrapper_mWeb'} style={captainBG}>
            <Text className={'choose-cap-player-captain-point-title_mWeb'} style={captainTitle}>
              {'2x'}
            </Text>
          </View>
        )}

        {viceCaptain && (
          <View className={'choose-cap-player-captain-pt-wrapper_mWeb'} style={viceCaptainBG}>
            <Text className={'choose-cap-player-captain-point-title_mWeb'} style={viceCaptainTitle}>
              {'1.5x'}
            </Text>
          </View>
        )}
        {playerRoleIcon(role)}
        <View
          className={'choose-cap-player-divider_mWeb'}
          style={{
            backgroundColor: isTeamA ? '#ffbe0f' : '#ff3c3c'
          }}
        />
      </View>
      <View className={'choose-cap-player-select-c-vc-wrapper_mWeb'}>
        <View
          className={'choose-cap-player-select-cap-wrapper_mWeb'}
          style={{
            backgroundColor: captain ? '#ffc400' : '#2d353f'
          }}
          onPress={() => selectedCaptain(item)}>
          <Text
            className={'choose-cap-player-select-cap-text_mWeb'}
            style={{
              color: captain ? '#000' : '#fff'
            }}>
            {'C'}
          </Text>
        </View>
        <View
          className={'choose-cap-player-select-cap-wrapper_mWeb'}
          style={{
            backgroundColor: viceCaptain ? '#ffc400' : '#2d353f'
          }}
          onPress={() => selectedViceCaptain(item)}>
          <Text
            className={'choose-cap-player-select-cap-text_mWeb'}
            style={{
              color: viceCaptain ? '#000' : '#fff'
            }}>
            {'VC'}
          </Text>
        </View>
      </View>
    </View>
  );
};
export default React.memo(ChooseCapPlayerRowMWeb);
